import * as React from "react";

function SvgGd6DLogoDashboard(props) {
  const { isDisabled, ...restProps } = props

  const palette = {
    default: ['#dd2c00', '#aeea00', '#00c853', '#64dd17', '#ffab00', '#263238'],
    disabled: ['#90A4AE', '#607D8B']
  }

  return (
    <svg
      id="GD6D__logo__dashboard_svg__Calque_1"
      data-name="Calque 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 381.09 129.54"
      {...restProps}
    >
      <defs>
        <style>
          {
            `.GD6D__logo__dashboard_svg__cls-1{fill:${isDisabled ? palette.disabled[0] : palette.default[5]}}
            .GD6D__logo__dashboard_svg__cls-2{fill:${isDisabled ? palette.disabled[1] : palette.default[0]}}
            .GD6D__logo__dashboard_svg__cls-3{fill:${isDisabled ? palette.disabled[1] : palette.default[1]}}
            .GD6D__logo__dashboard_svg__cls-4{fill:${isDisabled ? palette.disabled[1] : palette.default[2]}}
            .GD6D__logo__dashboard_svg__cls-5{fill:${isDisabled ? palette.disabled[1] : palette.default[3]}}
            .GD6D__logo__dashboard_svg__cls-6{fill:${isDisabled ? palette.disabled[1] : palette.default[4]}}`
          }
        </style>
      </defs>
      <path
        className="GD6D__logo__dashboard_svg__cls-1"
        d="M33.14 60.23h9.71c5.72 0 9.25 1 12.29 3.63a16.08 16.08 0 015.42 12.63 17.66 17.66 0 01-5.28 13.09c-2.73 2.49-6.76 3.83-11.54 3.83h-10.6zm8.07 26.56h1.24c5.87 0 9.95-4.08 9.95-10.05a10.83 10.83 0 00-3-7.66 10.32 10.32 0 00-6.61-2.39h-1.58zM83 70.38h7.6v23H83v-2.56a9.64 9.64 0 01-7.81 3.48c-6.57 0-11.29-5-11.29-12.08 0-7.37 5-12.74 11.94-12.74 2.93 0 4.92 1 7.16 3.38zM72 82.07c0 3.53 2.38 6.26 5.47 6.26s5.67-2.88 5.67-6.36c0-3.68-2.34-6.22-5.62-6.22S72 78.39 72 82.07zM106.17 77.19v-.45A2 2 0 00104 74.9a1.62 1.62 0 00-1.79 1.55c0 .94.7 1.49 2.64 2 6.47 1.84 8.81 4 8.81 8 0 4.68-3.74 7.81-9.36 7.81s-9.15-2.93-9.3-7.76h7.16c.3 1.7.85 2.34 2.14 2.34a1.64 1.64 0 001.7-1.6c0-1-.74-1.59-3.83-2.59-5-1.59-7.21-3.93-7.21-7.56 0-4.58 3.73-7.61 9.3-7.61s8.86 2.89 8.91 7.71zM125.28 72.51a7.48 7.48 0 016-3 8.89 8.89 0 015.62 2.14c1.59 1.44 2.19 3.23 2.19 6.72v15.04h-7.57V79.58c0-2.29-1.19-3.83-3-3.83-2 0-3.18 1.39-3.18 3.83v13.83h-7.57V60.23h7.57zM152.09 93.41h-7.56V60.23h7.56v12.43a8.89 8.89 0 017.16-3.18 12.23 12.23 0 018.66 3.63 12.54 12.54 0 013.23 8.89c0 7.41-4.62 12.28-11.64 12.28-3.38 0-5.47-.94-7.41-3.38zM152 82.17c0 3.53 2.34 6.16 5.47 6.16 3.28 0 5.62-2.58 5.62-6.26s-2.38-6.32-5.47-6.32-5.62 2.93-5.62 6.42zM199.89 82.17c0 6.81-5.72 12.13-13 12.13-7.46 0-12.88-5.17-12.88-12.38s5.32-12.44 13-12.44c7.46 0 12.88 5.32 12.88 12.69zm-18.3-.25c0 3.38 2.19 5.72 5.37 5.72a5.21 5.21 0 005.32-5.57c0-3.68-2-5.87-5.27-5.87s-5.42 2.29-5.42 5.72zM221.88 70.38h7.56v23h-7.56v-2.56a9.64 9.64 0 01-7.81 3.48c-6.57 0-11.29-5-11.29-12.08 0-7.37 5-12.74 11.94-12.74 2.93 0 4.92 1 7.16 3.38zm-11 11.69c0 3.53 2.38 6.26 5.47 6.26S222 85.45 222 82c0-3.68-2.34-6.22-5.62-6.22s-5.54 2.61-5.54 6.29zM242.68 70.38v3.13a5.06 5.06 0 012-3 5.79 5.79 0 013.33-1h.74v7.76c-.54 0-1.09-.1-1.39-.1a4.7 4.7 0 00-3.94 1.83c-.6.8-.74 1.64-.74 3.58v10.83h-7.57v-23zM269.84 60.23h7.56v33.18h-7.56v-2.59a6.51 6.51 0 01-2.69 2.49 10.87 10.87 0 01-4.78 1c-7 0-11.69-4.82-11.69-12.13a12 12 0 0111.84-12.69 9.73 9.73 0 017.32 3zm-11.1 21.94c0 3.48 2.44 6.16 5.62 6.16s5.48-2.68 5.48-6.16c0-3.68-2.34-6.42-5.48-6.42s-5.62 2.74-5.62 6.42zM157 44.82a1.06 1.06 0 000 .23 1.54 1.54 0 001.67 1.28c.82 0 1.45-.48 1.45-1.11s-.38-.95-2-1.54c-3.07-1.1-4.27-2.38-4.27-4.53 0-2.63 1.93-4.4 4.86-4.4a4.79 4.79 0 014.27 2.17 5.58 5.58 0 01.74 2.25h-3.47a1.39 1.39 0 00-1.56-1.41c-.84 0-1.39.45-1.39 1.12a1.12 1.12 0 00.65 1 7.52 7.52 0 001.6.7 9.07 9.07 0 013 1.57 3.71 3.71 0 011.13 2.85c0 2.61-2 4.36-5 4.36s-5-1.75-5-4.52zM168.9 43.2a3.7 3.7 0 00.48 2.19 2.17 2.17 0 001.73.8 2.14 2.14 0 001.83-.93 4.21 4.21 0 00.36-2.06V35h3.41v8a6.67 6.67 0 01-1.46 4.67 5.53 5.53 0 01-4.12 1.62 5.79 5.79 0 01-4.34-1.75c-.9-1-1.3-2.35-1.3-4.54v-8h3.41zM182.58 49.07h-3.41V35H184c3.32 0 5.22 1.68 5.22 4.61a4.63 4.63 0 01-5 4.86h-1.62zm.94-7.37c1.42 0 2.24-.71 2.24-1.93a1.86 1.86 0 00-2-1.94h-1.18v3.87zM194.13 40.65h4.63v2.76h-4.63v2.9h4.63v2.76h-8V35h8v2.76h-4.63zM204.42 49.07H201V35h4.55a6.69 6.69 0 014.13 1 4.4 4.4 0 011.51 3.56 4.16 4.16 0 01-2.71 4.27l3.09 5.16h-4.07l-3.08-5.43zm1.1-7.35c1.41 0 2.23-.71 2.23-1.93a1.87 1.87 0 00-2-2h-1.31v3.89zM220.46 35H224l-4.23 14H216l-4-14h3.52l2.37 8.57zM228.82 49.07h-3.41V35h3.41zM234.08 44.82a1.06 1.06 0 000 .23 1.52 1.52 0 001.66 1.28c.82 0 1.45-.48 1.45-1.11s-.38-.95-2-1.54c-3.07-1.1-4.27-2.38-4.27-4.53 0-2.63 1.93-4.4 4.86-4.4a4.79 4.79 0 014.22 2.17 5.58 5.58 0 01.74 2.25h-3.47a1.39 1.39 0 00-1.56-1.41c-.84 0-1.39.45-1.39 1.12a1.12 1.12 0 00.65 1 7.52 7.52 0 001.6.7 9.07 9.07 0 013 1.57 3.71 3.71 0 011.18 2.85c0 2.61-2 4.36-5 4.36s-5-1.75-5-4.52zM246.18 49.07h-3.41V35h3.41zM263.1 42.08a7.43 7.43 0 11-12.5-5.37 7.56 7.56 0 015.24-2 7.12 7.12 0 017.26 7.37zm-11.39 0a4 4 0 104-4.15 4 4 0 00-4 4.13zM268.55 49.07h-3.41V35h3.41l5.12 7.89V35h3.41v14h-3.41l-5.12-8z"
      />
      <circle
        className="GD6D__logo__dashboard_svg__cls-2"
        cx={319.71}
        cy={90.07}
        r={6.33}
      />
      <circle
        className="GD6D__logo__dashboard_svg__cls-3"
        cx={319.71}
        cy={39.47}
        r={6.33}
      />
      <circle
        className="GD6D__logo__dashboard_svg__cls-4"
        cx={341.62}
        cy={77.42}
        r={6.33}
      />
      <circle
        className="GD6D__logo__dashboard_svg__cls-5"
        cx={341.62}
        cy={52.12}
        r={6.33}
      />
      <circle
        className="GD6D__logo__dashboard_svg__cls-6"
        cx={297.8}
        cy={77.42}
        r={6.33}
      />
      <circle cx={297.8} cy={60.55} r={6.13} opacity={0.33} fill={isDisabled ? palette.disabled[1] : "#ffd600"} />
      <circle cx={297.8} cy={56.34} r={6.13} opacity={0.67} fill={isDisabled ? palette.disabled[1] : "#ffd600"} />
      <circle cx={297.8} cy={52.12} r={6.33} fill={isDisabled ? palette.disabled[1] : "#ffd600"} />
      <circle cx={305.1} cy={81.64} r={6.13} opacity={0.33} fill={isDisabled ? palette.disabled[1] : palette.default[4]} />
      <circle cx={301.45} cy={79.53} r={6.13} opacity={0.67} fill={isDisabled ? palette.disabled[1] : palette.default[4]} />
      <circle
        className="GD6D__logo__dashboard_svg__cls-6"
        cx={297.8}
        cy={77.42}
        r={6.33}
      />
      <circle cx={327.01} cy={85.85} r={6.13} opacity={0.33} fill={isDisabled ? palette.disabled[1] : palette.default[0]} />
      <circle cx={323.36} cy={87.96} r={6.13} opacity={0.67} fill={isDisabled ? palette.disabled[1] : palette.default[0]} />
      <circle
        className="GD6D__logo__dashboard_svg__cls-2"
        cx={319.71}
        cy={90.07}
        r={6.33}
      />
      <circle cx={341.62} cy={68.99} r={6.13} opacity={0.33} fill={isDisabled ? palette.disabled[1] : palette.default[2]} />
      <circle cx={341.62} cy={73.2} r={6.13} opacity={0.67} fill={isDisabled ? palette.disabled[1] : palette.default[2]} />
      <circle
        className="GD6D__logo__dashboard_svg__cls-4"
        cx={341.62}
        cy={77.42}
        r={6.33}
      />
      <circle cx={334.32} cy={47.9} r={6.13} opacity={0.33} fill={isDisabled ? palette.disabled[1] : palette.default[3]} />
      <circle cx={337.97} cy={50.01} r={6.13} opacity={0.67} fill={isDisabled ? palette.disabled[1] : palette.default[3]} />
      <circle
        className="GD6D__logo__dashboard_svg__cls-5"
        cx={341.62}
        cy={52.12}
        r={6.33}
      />
      <circle cx={312.41} cy={43.69} r={6.13} opacity={0.33} fill={isDisabled ? palette.disabled[1] : palette.default[1]} />
      <circle cx={316.06} cy={41.58} r={6.13} opacity={0.67} fill={isDisabled ? palette.disabled[1] : palette.default[1]} />
      <circle
        className="GD6D__logo__dashboard_svg__cls-3"
        cx={319.71}
        cy={39.47}
        r={6.33}
      />
    </svg>
  );
}

export default SvgGd6DLogoDashboard;
